import { makeStyles } from '@mui/styles';
import { sectionCommonStyle } from '../shared/sections-common-style';

export const useStyles = makeStyles((theme) => ({
  ...sectionCommonStyle,
  locationsContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
}));
